import Terminal from '@/models/Terminal';
import Device from '@/wrappers/Device';
import AppEvent from '@/models/AppEvent';
import Store from '@/store';
import * as mutationTypes from '@/store/mutationTypes';
import { AriaCapacitor } from '@codeus/aria-capacitor';

export default {
    terminal: null,
    canBecomeServer: false,
    serviceRunning: false,
    connectionStatus: undefined,

    async init() {
        if(Device.isWeb()) return

        this.terminal = await Terminal.current()
        this.canBecomeServer = Device.isElectron() && this.terminal?.type === 'cashRegister'

        if(Device.isElectron()) {
            window.electron.on('lanEvent', (event, eventData) => this.onEventReceived(eventData))
            window.electron.on('lanConnectionUpdate', (event, eventData) => this.onConnectionUpdate(eventData))
        } else if(Device.isMobile()) {
            AriaCapacitor.addListener('lanEvent', (eventData) => this.onEventReceived(eventData))
            AriaCapacitor.addListener('lanConnectionUpdate', (eventData) => this.onConnectionUpdate(eventData))
        }
    },

    async reload() {
        if(Device.isWeb()) return

        if(this.serviceRunning) {
            await this.shutdown()
        }

        this.terminal = await Terminal.current()
        if(!this.terminal) return

        this.canBecomeServer = Device.isElectron() && this.terminal.type === 'cashRegister'

        const tenant = Store.getters.tenant
        if (!tenant?.venue) return

        this.serviceRunning = true

        if(Device.isElectron()) {
            await window.electron.invoke('lanReload', this.terminal, this.canBecomeServer, tenant.venue.hash)
        } else if(Device.isMobile()) {
            await AriaCapacitor.lanReload({ terminal: this.terminal, canBecomeServer: false, hash: tenant.venue.hash })
        }
    },

    async shutdown() {
        if(!this.terminal) return

        if(Device.isElectron()) {
            await window.electron.invoke('lanShutdown')
        } else if(Device.isMobile()) {
            await AriaCapacitor.lanShutdown()
        }

        this.serviceRunning = false
    },

    onEventReceived(event) {
        if(!this.terminal) return

        AppEvent.handle(event)
    },

    onConnectionUpdate(data) {
        if(!this.terminal) return

        this.connectionStatus = data
        Store.commit(mutationTypes.SET_LOCAL_CONNECTION, { localConnection: data });
    },

    async getTerminals() {
        if(!this.terminal || !Device.isElectron()) return []

        const terminals = await window.electron.invoke('lanTerminals')
        return terminals
    },

    async send(data) {
        if(!this.terminal) return { status: 'failed', error: 'not_supported' }

        if(Device.isElectron()) {
            return window.electron.invoke('lanEvent', data)
        } else if(Device.isMobile()) {
            return AriaCapacitor.lanSendEvent(data)
        }

        return { status: 'failed', error: 'not_supported' }
    }
}
